// NEW_FILE_JUSTIFIED: Searchable country select for driver nationality/license fields — no existing combobox in codebase
import { useState } from 'react';
import { Check, ChevronsUpDown } from 'lucide-react';
import { cn } from '@/lib/utils';
import { Button } from '@/components/ui/button';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
} from '@/components/ui/command';
import { COUNTRIES } from '@/lib/countries';
import type { ICountryComboboxProps } from '@/@types/insurance';

export function CountryCombobox({ value, onChange, placeholder, disabled }: ICountryComboboxProps) {
  const [open, setOpen] = useState(false);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          variant="outline"
          role="combobox"
          aria-expanded={open}
          aria-controls="country-combobox-list"
          disabled={disabled}
          className={cn(
            'w-full !h-10 justify-between font-normal',
            !value && 'text-muted-foreground'
          )}
        >
          {value || placeholder || 'Select country'}
          <ChevronsUpDown className="ml-2 h-4 w-4 shrink-0 opacity-50" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-(--radix-popover-trigger-width) p-0" align="start">
        <Command>
          <CommandInput placeholder="Search country..." />
          <CommandList id="country-combobox-list">
            <CommandEmpty>No country found.</CommandEmpty>
            <CommandGroup>
              {COUNTRIES.map(country => (
                <CommandItem
                  key={country}
                  value={country}
                  className="data-[selected=true]:text-white"
                  onSelect={selected => {
                    onChange(selected === value ? '' : selected);
                    setOpen(false);
                  }}
                >
                  <Check
                    className={cn('mr-2 h-4 w-4', value === country ? 'opacity-100' : 'opacity-0')}
                  />
                  {country}
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
}
